import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';

interface GranularitySelectorProps<T> {
  options: T[];
  selected: T;
  onSelect: (item: T) => void;
  getKey: (item: T) => string;
  getLabel: (item: T) => string;
  isSelected: (item: T, selected: T) => boolean;
  minWidth?: string;
}

export const GranularitySelector = <T,>({
  options,
  selected,
  onSelect,
  getKey,
  getLabel,
  isSelected,
  minWidth = '160px',
}: GranularitySelectorProps<T>) => {
  if (options.length <= 1) return null;

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="xs"
        variant="ghost"
        color="blue.500"
        fontWeight="normal"
        px={1}
        h="auto"
        minH="auto"
        lineHeight="1.4"
      >
        ▾
      </MenuButton>
      <MenuList minW={minWidth} zIndex={20}>
        {options.map((item) => (
          <MenuItem
            key={getKey(item)}
            fontSize="sm"
            fontWeight={isSelected(item, selected) ? 'bold' : 'normal'}
            onClick={() => onSelect(item)}
          >
            {getLabel(item)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
